// extracted by mini-css-extract-plugin
export default {"PremierDeliveryLoading":"PremierDeliveryLoading_PremierDeliveryLoading"};